import React from "react";
import { CheckCircle2 } from "lucide-react";

const HERITAGE_IMG = "https://images.pexels.com/photos/34561170/pexels-photo-34561170.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900";
const SPICES_IMG = "https://images.pexels.com/photos/32281630/pexels-photo-32281630.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=600&w=600";

export default function Heritage({ t }) {
  return (
    <section id="heritage" className="relative py-24 md:py-32 bg-stone-base" data-testid="heritage-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        {/* Left: Imagery */}
        <div className="lg:col-span-5 relative">
          <div className="relative aspect-[4/5] rounded-2xl overflow-hidden ring-1 ring-stone-800">
            <img src={HERITAGE_IMG} alt="130 year heritage spices" className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-stone-950/80 via-transparent to-transparent" />
            <div className="absolute bottom-6 left-6 right-6">
              <div className="font-serif text-amber-500 text-4xl leading-none">est. 1890</div>
              <div className="text-stone-300 text-xs uppercase tracking-[0.3em] mt-2">Meerapur · Prayagraj</div>
            </div>
          </div>

          <div className="hidden md:block absolute -bottom-10 -right-8 w-48 h-48 rounded-2xl overflow-hidden ring-1 ring-amber-600/40 shadow-2xl">
            <img src={SPICES_IMG} alt="spices" className="w-full h-full object-cover" />
          </div>
        </div>

        {/* Right: copy */}
        <div className="lg:col-span-7">
          <div className="text-amber-500 text-xs uppercase tracking-[0.3em] mb-4">{t.eyebrow}</div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-stone-50 leading-tight">{t.title}</h2>

          <div className="mt-8 space-y-5 text-stone-300 text-base md:text-lg leading-relaxed">
            <p>{t.p1}</p>
            <p>{t.p2}</p>
          </div>

          <div className="mt-10 heritage-card p-6 md:p-8 relative overflow-hidden">
            <div className="absolute -top-12 -right-12 w-40 h-40 rounded-full bg-amber-600/10 blur-3xl" />
            <div className="relative">
              <div className="text-amber-500 text-xs uppercase tracking-[0.3em] mb-2">{t.ghee_label}</div>
              <p className="text-stone-200 text-lg leading-relaxed">{t.ghee_text}</p>
            </div>
          </div>

          <div className="mt-8 flex flex-wrap gap-3">
            {[t.pill_1, t.pill_2, t.pill_3].map((p) => (
              <span
                key={p}
                className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-stone-700 bg-stone-900 text-stone-200 text-sm"
              >
                <CheckCircle2 size={14} className="text-amber-500" />
                {p}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
